import { currentOrganizationVar } from "@cache/cache";

import {
  ExplorerFilterType,
  explorerGithubType,
  explorerHubspotType,
  explorerJiraType,
  explorerYouTrackType,
  isIntegrationSetup,
} from "../helpers";

const ExplorerIntegrationsNeedQuery = ({
  filters,
  className = "",
}: {
  filters: ExplorerFilterType;
  className?: string;
}) => {
  let title = "Please enter a search query.";
  let docUrl = null;
  let docLink = null;
  if (!isIntegrationSetup(filters.type)) {
    const currentOrganization = currentOrganizationVar();
    title =
      filters.type === explorerGithubType
        ? "Please setup the Github integration in your account settings."
        : filters.type === explorerJiraType
          ? "Please setup the Jira integration in your account settings."
          : filters.type === explorerHubspotType
            ? "Please setup the Hubspot integration in your account settings."
            : filters.type === explorerYouTrackType
              ? "Please ask your Admin to setup YouTrack integration in your organization settings."
              : "Please setup integration";
    docUrl =
      filters.type === explorerYouTrackType
        ? `/settings/organization/${currentOrganization?.id || ""}/integrations`
        : "/account/integrations";
    docLink =
      filters.type === explorerYouTrackType
        ? "Organization settings"
        : "Account settings";
  } else if (filters.type === explorerGithubType && filters.search === "") {
    title = "Please enter a Github search query.";
    docUrl =
      "https://docs.github.com/en/search-github/searching-on-github/searching-issues-and-pull-requests";
    docLink = "Github documentation for searching issues and pull requests";
  } else if (filters.type === explorerYouTrackType && filters.search === "") {
    title = "Please enter a YouTrack search query.";
    docUrl =
      "https://www.jetbrains.com/help/youtrack/server/Search-and-Command-Attributes.html";
    docLink = "YouTrack documentation for search queries";
  }

  return (
    <div className={className}>
      <div className="py-4 flex flex-col gap-3 w-full">
        <div>{title}</div>
        {docUrl && (
          <div>
            <a
              className="text-blue-link hover:underline text-xs tracking-tight"
              href={docUrl}
            >
              {docLink}
            </a>
            .
          </div>
        )}
      </div>
    </div>
  );
};

export default ExplorerIntegrationsNeedQuery;
